import { HomepageUploadSummary } from "../../../graphql/types";
import { TransferRow } from "./TransferRow";
import { hasAllDaysMissing } from "./utils";
const getUploadStatus = (
  upload: Omit<HomepageUploadSummary, "reportDatetimes" | "status" | "dependencies" | "keys">
) => {
  const isUploadSuspended = upload.artifactStatus === "suspended";
  const isUploadBlocked = upload.dependencyStatus === "blocked" || upload.dependencyStatus === "suspended";

  const allDaysMissing = hasAllDaysMissing(upload.sparkline);
  if (isUploadSuspended) {
    if (allDaysMissing) {
      return {
        msg: "This upload is suspended, and has not run for over 7 days.",
        status: "error",
      };
    }
    // at this point, we have at least 7 uploads missing (because there are no events related), but the last one has "expected" status
    return {
      msg: upload.event?.message || "Upload is suspended",
      status: upload.event?.severity || "error",
    };
  }

  if (isUploadBlocked) {
    return {
      msg: "Upload is blocked",
      status: "warn",
    };
  }
  if (allDaysMissing) {
    return {
      msg: "This upload has not run in over seven days",
      status: "warn",
    };
  }
  if (upload.event?.message) {
    return {
      msg: upload.event.message,
      status: upload.event.severity,
    };
  }
  return {
    msg: upload.event?.message || "This upload is running without issues.",
    status: upload.event?.severity || "success",
  };
};

type UploadRowProps = {
  upload: Omit<HomepageUploadSummary, "reportDatetimes" | "status" | "dependencies" | "keys">;
  isDark: boolean;
  sparklineFirstDate: string;
  refreshData: () => Promise<void>;
  refreshing: boolean;
};

const UploadRow = ({ upload, isDark, sparklineFirstDate, refreshData, refreshing }: UploadRowProps) => {
  return (
    <TransferRow
      name={upload.name}
      sparkline={upload.sparkline}
      isDark={isDark}
      sparklineFirstDate={sparklineFirstDate}
      transferStatus={getUploadStatus(upload)}
      type="upload"
      destination={upload.destination ?? undefined}
      artifactStatus={upload.artifactStatus}
      refreshData={refreshData}
      refreshing={refreshing}
    />
  );
};

export { UploadRow };
